/**
 * AuthContext — global auth state for NutriSakti
 * Provides: user, login(), logout(), isAuthenticated, loading
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import * as api from './api';

const AuthCtx = createContext({});
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session on mount
  useEffect(() => {
    const token = localStorage.getItem('ns_token');
    if (!token) { setLoading(false); return; }
    api.getMe()
      .then(res => { if (res.user) setUser(res.user); })
      .catch(() => localStorage.removeItem('ns_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await api.login(username, password);
    if (res.error) throw new Error(res.error);
    localStorage.setItem('ns_token', res.token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem('ns_token');
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, isAuthenticated: !!user, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}
